<template>
  <div>
    <div class="container">
      <h1 class="title">{{deviceName}}-火灾报警控制器操作台(海湾-{{deviceVersion | dic("SENU095")}} )</h1>
      <div class="main">
        <div class="main-box">
          <!-- left 键盘 -->
          <div :class="['fireType'+fireType,'select-group-box'] "></div>
          <div class="view-box">
            {{respondText}}
          </div>
          <div class="btn-group-box">
            <div class="btn-group">
              <div class="reset-btn red btn ctl-btn"
                   name="1">复位</div>
              <div class="trans-btn red btn ctl-btn"
                   name="32">火警传输</div>
              <div class="other-btn red ctl-btn"
                   name="33">
                <div>报警器</div>
                <div>消音/启动</div>
              </div>
            </div>
            <div class="control-btn-group">
              <div class="confirm-btn control-btn ctl-btn"
                   name="3"></div>
              <div class="control-main">
                <div class="ctl-top ctl-btn"
                     name="5"></div>
                <div class="ctl-right ctl-btn"
                     name="8"></div>
                <div class="ctl-bottom ctl-btn"
                     name="6"></div>
                <div class="ctl-left ctl-btn"
                     name="7"></div>
                <div class="ctl-center ctl-btn"
                     name="2"></div>
              </div>
              <div class="close-btn control-btn ctl-btn"
                   name="4"></div>
            </div>
            <div class="number-btn-group">
              <div class="b1 ctl-btn"
                   name="10"></div>
              <div class="b2 ctl-btn"
                   name="11"></div>
              <div class="b3 ctl-btn"
                   name="12"></div>
              <div class="b4 ctl-btn"
                   name="13"></div>
              <div class="b5 ctl-btn"
                   name="14"></div>
              <div class="b6 ctl-btn"
                   name="15"></div>
              <div class="b7 ctl-btn"
                   name="16"></div>
              <div class="b8 ctl-btn"
                   name="17"></div>
              <div class="b9 ctl-btn"
                   name="18"></div>
              <div class="b10 ctl-btn"
                   name="19"></div>
              <div class="b11 ctl-btn"
                   name="9"></div>
              <div class="b12 ctl-btn"
                   name="31"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './minx';
import { Dic } from '$utils'
export default {
  mixins: [mixin],
  props: {
    fireType: {
      type: Number,
      default: () => {
        return 1
      }
    },
    deviceVersion: {
      type: String,
      default: () => {
        return ""
      }
    },
    deviceName: {
      type: String,
      default: () => {
        return ""
      }
    }
  },

  data () {
    return {
      controlType: "1"
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../../style/index.scss";
</style>